// extracted by mini-css-extract-plugin
export var bubble = "_2u-0";
export var container = "_2u-3";
export var contrastBorder = "_2u-4";
export var greyOut = "_2u-2";
export var initialsWrapper = "_2u-1";
export var large = "_2u-9";
export var medium = "_2u-8";
export var mediumSmall = "_2u-7";
export var mediumSmallMedium = "_2u-c";
export var micro = "_2u-5";
export var small = "_2u-6";
export var tiny = "_2u-b";
export var xTiny = "_2u-a";